import { io, Socket } from 'socket.io-client'

const GAME_SERVER = import.meta.env.VITE_GAME_SERVER_URL || 'http://localhost:3002'
let _socket: Socket | null = null

export const getSocket = (token: string): Socket => {
  if (_socket) return _socket
  _socket = io(GAME_SERVER, {
    auth:                 { token },
    transports:           ['polling'],
    reconnectionAttempts: 10,
    reconnectionDelay:    1000,
    timeout:              20000,
  })
  return _socket
}

export const disconnectSocket = () => {
  _socket?.disconnect()
  _socket = null
}
